import type { ProductType } from '@econtractor/types';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import EmptyResult from 'components/others/EmptyResult';
import ProductTableRow from './ProductTableRow';
import { useProduct } from './context/ProductProvider';

interface ProductTableBodyProps {
    productsList: ProductType[];
    fetchProducts: (force?: boolean) => Promise<unknown>;
}

const ProductTableBody = ({ productsList, fetchProducts }: ProductTableBodyProps) => {
    const { auth } = useAuth();
    const { showCategory, showVendor, showId, showArticle, showUpdated } = useProduct();
    const colSpan = 3
        + (showCategory ? 1 : 0)
        + (showVendor ? 1 : 0)
        + (showId ? 1 : 0)
        + (showArticle ? 1 : 0)
        + (showUpdated ? 1 : 0)
        + (hasUserAccess(auth?.user, 'prodEdit') ? 1 : 0);

    return (
        <tbody>
            {productsList?.map((product) => (
                <ProductTableRow key={product.ID} product={product} fetchProducts={fetchProducts} />
            ))}

            {productsList.length === 0 && (
                <tr>
                    <td colSpan={colSpan}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default ProductTableBody;
